import createVueApp from '@phoenix/createVueApp';
import YoutubeVideo from '../components/common/YoutubeVideo.vue';

Array.from(document.querySelectorAll('.phoenix-youtube-video')).forEach((el) => {
  const app = createVueApp();
  app.component('YoutubeVideo', YoutubeVideo);
  app.mount(el);
});
